export default __webpack_public_path__ + "static/media/studio_vid.c6e4850e.mp4";